module.exports = __webpack_public_path__ + "static/img/3-3档案袋@2x.c9be9e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-img/3-3档案袋@2x.png
// module id = ZAHy
// module chunks = 17